<template>
  <div
    v-if="images && images.length > 0"
    class="w-full lg:cursor-none"
    ref="wrapper"
  >
    <div
      ref="scroll"
      class="
        w-full
        h-full
        flex
        overflow-x-scroll
        lg:overflow-x-visible
        touch-action
      "
      :style="{ transform: 'translateX(-' + offset + 'px)' }"
    >
      <div
        class="pr-4 flex-0 h-full w-auto"
        v-for="(file, index) in images"
        :key="index"
        :data-index="index"
        ref="item"
        @click="scrollTo"
        @mousemove="changeCursor"
        @mouseleave="leaveCursor"
      >
        <img
          class="transition-height h-1/3 w-auto block"
          :class="{ active: big }"
          data-sizes="auto"
          :alt="file.caption"
          :data-index="index"
          :src="file.thumb"
          :srcset="file.srcset"
        />
        <figcaption v-if="big" class="w-full pt-2 uppercase text-xs">
          {{ file.caption }}
        </figcaption>
      </div>
      <div
        class="flex-0 w-screen h-1/3"
        :class="{ active: big }"
        @mousemove="backCursor"
        @mouseleave="leaveCursor"
        @click="goBack"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    images: Array,
  },
  data() {
    return {
      big: false,
      slideIndex: 0,
      offset: 0,
    };
  },
  mounted() {
    this.$refs.scroll.addEventListener("wheel", this.scrollPanel);
    this.$root.$on("expandPanel", this.toggle);
  },
  methods: {
    scrollPanel(event) {
      if (event.deltaX < 0) {
        event.preventDefault();
      }
      this.$refs.scroll.classList.remove("trheight");
      let maxWidth = 0;
      for (var i = 0; i < this.$refs.item.length; i++) {
        maxWidth = maxWidth + parseInt(this.$refs.item[i].offsetWidth);
      }
      if (this.offset >= 0 && this.offset <= maxWidth) {
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
          this.offset = this.offset + event.deltaX;
        }
      }
      if (this.offset < 0) {
        this.offset = 0;
      }
      if (this.offset > maxWidth) {
        this.offset = maxWidth;
      }
    },
    toggle() {
      this.big = !this.big;
    },
    scrollTo(event) {
      if (window.innerWidth > 768) {
        let index = event.target.dataset.index;
        this.$refs.scroll.classList.add("trheight");
        if (this.big) {
          this.$root.$emit("changeCursor", "MAXIMIZE");
        } else {
          this.$root.$emit("changeCursor", "MINIMIZE");
        }
        this.big = !this.big;
        this.slideIndex = index;
        this.$root.$emit("expandText");
        if (index == this.images.length - 1) {
          this.$root.$emit("changeCursor", "BACK");
        }
        setTimeout(() => {
          this.offset = event.target.offsetLeft;
        }, 500);
        setTimeout(() => {
          this.$refs.scroll.classList.remove("trheight");
        }, 1000);
      }
    },
    changeCursor(event) {
      // let index = event.target.dataset.index;
      if (event.target.tagName !== "FIGCAPTION") {
        // if (this.slideIndex == index) {
        if (!this.big) {
          this.$root.$emit("changeCursor", "MAXIMIZE");
        } else {
          this.$root.$emit("changeCursor", "MINIMIZE");
        }
        // } else {
        // this.$root.$emit("changeCursor", "MAXIMIZE");
        // }
      } else {
        this.$root.$emit("changeCursor", "");
      }
    },
    backCursor() {
      this.$root.$emit("changeCursor", "BACK");
    },
    leaveCursor() {
      this.$root.$emit("changeCursor", "");
    },
    goBack() {
      this.$refs.scroll.classList.add("trheight");
      this.offset = 0;
      this.slideIndex = 0;
      setTimeout(() => {
        this.$refs.scroll.classList.remove("trheight");
      }, 500);
    },
  },
};
</script>
